export type ShadowSettings = {
    offsetX: number;
    offsetY: number;
    blur: number;
    spread: number;
    color: string;
};

export const DEFAULT_SHADOW_SETTINGS: ShadowSettings = {
    offsetX: 0,
    offsetY: 0,
    blur: 12,
    spread: 4,
    color: 'rgba(0, 0, 0, .08)',
};
